import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";
import {
  VOID_CONFIRM_MESSAGE,
  VOID_STATUS_FIELD,
} from "../utils/voidTransactionConfig";

export const screen_115_parts_return: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "121",
      action: "modulev1/parts_return",
    },
    title: "Parts return",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "return_no",
            Name: "parts_return_summary",
            SummeryActions: [
              {
                ActionType: ActionType.VIEW_REPORT,
                Action: {
                  Action: "Report",
                  Api: "parts_return_view",
                },
                tooltip: "View Report",
              },
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/parts_return/<id>",
                },
                ActionType: "View",
                ScreenId: "121",
                tooltip: "View",
              },
                            {
                ActionType: ActionType.VOID,
                permissionKey: "Void",
                confirmMessage: VOID_CONFIRM_MESSAGE,
                requireVoidReason: true,
                hiddenWhenVoid: true,
                visibleWhenNotDraft: true,
                voidReasonLabel: "Void Reason",
                tooltip: "Void",
                Action: {
                  Module: "parts_return",
                  TransactionNoField: "spare_return_no",
                },
              },
            ],
            Form: {
              Name: "parts_return_summary",
              TableName: "service_spare_part_return",
              DisplayName: "Parts return",
              Query:
                "SELECT service_spare_part_return.id, return_no, return_date, spare_issue_no, service_spare_part_return.is_void, CASE WHEN COALESCE(service_spare_part_return.is_void, 0) = 1 THEN 'Void' ELSE '' END AS status FROM service_spare_part_return LEFT JOIN service_spare_part_issue ON service_spare_part_issue.id = service_spare_part_return.issue_id",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                VOID_STATUS_FIELD,
                {
                  IncludeLabel: true,
                  Label: "Return No.",
                  BindValue: "txt_est",
                  Json_Attribute: "return_no",
                  componentType: ComponentType.TEXT_FIELD,
                  AutoPopulate: true,
                  AutoPopulate_format: "PRN_[******]",
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Issue No.",
                  BindValue: "txt_issue",
                  Json_Attribute: "spare_issue_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Return date",
                  BindValue: "txt_returndate",
                  Json_Attribute: "return_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: false,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
